import * as React from 'react';
import { t } from 'i18next';

import { BaseHamburgerTab } from './BaseHamburgerTab';
import { HamburgerTab } from '../../constants/Enums';
import { AppConfigurationStore, DownloadOption } from '../../stores/AppConfigurationStore';
import { HamburgerContentWrapper } from './HamburgerContentWrapper';
import { DownloadHelper } from '../../utils/DownloadHelper';
import { ArticleListMaker } from '../../utils/ArticleListMaker';
import { DownloadTileButton } from '../DownloadTileButton';

export class DownloadTab extends BaseHamburgerTab<{}> {
    protected previous: HamburgerTab = HamburgerTab.MENU;
    protected importInputElement: HTMLInputElement;
    protected importTypicalElement: HTMLInputElement;

    public render(): JSX.Element {
        return (
            <HamburgerContentWrapper className={this.getCSSClass()} header={this.header()}>
                <div className="long-button-group2">
                    <DownloadTileButton onClick={DownloadHelper.downloadScreenshot}>{t('Image')}</DownloadTileButton>
                </div>
                <div className="long-button-group2">
                    <div className="long-button-group2__header">{t('Commercial Information')}</div>
                    {AppConfigurationStore.getState().articleListTypes.map((downloadOption: DownloadOption, index: number) => {
                        return <DownloadTileButton key={index + '-al'} option={downloadOption} callback={ArticleListMaker.download}/>;
                    })}
                    {AppConfigurationStore.getState().commercialDownloadTypes.map((downloadOption: DownloadOption, index: number) => {
                        return <DownloadTileButton key={index + '-com'} option={downloadOption} callback={DownloadHelper.downloadExport}/>;
                    })}
                </div>
                <div className="long-button-group2">
                    <div className="long-button-group2__header">{t('CAD Symbols')}</div>
                    {AppConfigurationStore.getState().cadDownloadTypes.map((downloadOption: DownloadOption, index: number) => {
                        return <DownloadTileButton key={index + '-cad'} option={downloadOption} callback={DownloadHelper.downloadExport}/>;
                    })}
                </div>
            </HamburgerContentWrapper>
        );
    }

    protected getLabel(): string {
        return t('Download');
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/hamburgermenu/DownloadTab.tsx